import { createContext, use, useEffect, useState } from 'react';
import { Spinner } from '@airbus/components-react';
import { getApiBaseUrl } from '../utils/apiBase';

type Config = {
  cognitoDomain?: string;
  clientId?: string;
  redirectUri?: string;
};

const ConfigContext = createContext<Config>({});

export function ConfigContextProvider({ children }: { children: React.ReactNode }) {
  const [config, setConfig] = useState<Config>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      const apiBase = getApiBaseUrl();
      const result = await fetch(`${apiBase}/api/fetchConfig`);
      const jsonResult = await result.json();
      setConfig(jsonResult);
      setLoading(false);
    };
    fetchConfig();
  }, []);

  if (loading) {
    return <Spinner />;
  }

  return <ConfigContext value={config}>{children}</ConfigContext>;
}

export function useConfigContext(): Config {
  return use(ConfigContext);
}
